import WoltProposalSearchModal from './WoltProposalSearchModal';

export default WoltProposalSearchModal;
